// src/utils/analytics.ts
export const trackVisit = async () => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    try {
        let visitorId = localStorage.getItem("visitor_id");
        if (!visitorId) {
            visitorId = crypto.randomUUID();
            localStorage.setItem("visitor_id", visitorId);
        }

        await fetch(`${BASE_URL}/track-visit/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                visitor_id: visitorId,
                user_agent: navigator.userAgent,
                ip_address: undefined, // server infers this
            }),
        });
    } catch (error) {
        console.error("Visit tracking failed:", error);
    }
};
